import { render, staticRenderFns } from "./ExampleLedger.vue?vue&type=template&id=53844638&"
import script from "./ExampleLedger.vue?vue&type=script&lang=js&"
export * from "./ExampleLedger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports